import { useState } from "react";
import axios, { API } from "../../api";

export function ShareToStoriesToggle({ contentType, contentId, currentlyPublic, currentDisplayMode = "named" }) {
  const [isPublic, setIsPublic] = useState(currentlyPublic || false);
  const [displayMode, setDisplayMode] = useState(currentDisplayMode);
  const [saving, setSaving] = useState(false);

  const handleToggle = async () => {
    setSaving(true);
    try {
      const newPublic = !isPublic;
      await axios.post(`${API}/stories/share`, {
        content_type: contentType,
        content_id: contentId,
        is_public: newPublic,
        display_mode: displayMode
      });
      setIsPublic(newPublic);
    } catch (error) {
      console.error("Share to stories error:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleModeChange = async (newMode) => {
    setDisplayMode(newMode);
    if (isPublic) {
      try {
        await axios.post(`${API}/stories/share`, {
          content_type: contentType,
          content_id: contentId,
          is_public: true,
          display_mode: newMode
        });
      } catch (error) {
        console.error("Mode update error:", error);
      }
    }
  };

  return (
    <div className="share-to-stories">
      <div className="settings-toggle-row">
        <div className="settings-toggle-info">
          <strong>🌍 Share to Aura Stories</strong>
          <span>{isPublic ? 'Visible to everyone' : 'Private to you'}</span>
        </div>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={isPublic}
            onChange={handleToggle}
            disabled={saving}
            data-testid={`share-stories-toggle-${contentId}`}
          />
          <span className="toggle-slider"></span>
        </label>
      </div>
      {isPublic && (
        <div className="display-mode-selector">
          <button
            className={`mode-btn ${displayMode === 'named' ? 'active' : ''}`}
            onClick={() => handleModeChange('named')}
            data-testid={`mode-named-${contentId}`}
          >
            Show my name
          </button>
          <button
            className={`mode-btn ${displayMode === 'anonymous' ? 'active' : ''}`}
            onClick={() => handleModeChange('anonymous')}
            data-testid={`mode-anon-${contentId}`}
          >
            Anonymous
          </button>
        </div>
      )}
    </div>
  );
}
